import {ThemeConfig} from "antd/es/config-provider/context";


export const Theme: ThemeConfig = {
  token: {
    colorPrimary: '00BDF4',
    colorText: '130F26',
  },
  components: {
    Layout: {
      headerBg: 'transparent',
      bodyBg: 'transparent',
      footerBg: 'transparent',
      headerHeight: 72,
      headerPadding: 0,
      footerPadding: '24px 0',
    },
    Input: {
      inputFontSize: 18,
      borderRadius: 8,
      paddingBlock: 8,
      activeBorderColor: '#FF9500',
      hoverBorderColor: '#FF9500',
    },
    Typography: {
      // fontFamily: '"Be Vietnam Pro", monospace',
    }
  }
}